"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseMenuItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _menuItemContainer = _interopRequireDefault(require("../containers/menuItemContainer"));

var _utils = require("../utils");

var propTypes = {
  onClick: _propTypes.default.func
};
var defaultProps = {
  onClick: _utils.noop
};

var BaseMenuItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(BaseMenuItem, _React$Component);

  function BaseMenuItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleClick", function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;
      e.preventDefault();
      !disabled && onClick(e);
    });
    return _this;
  }

  var _proto = BaseMenuItem.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        active = _this$props2.active,
        children = _this$props2.children,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        onClick = _this$props2.onClick,
        onMouseDown = _this$props2.onMouseDown,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["active", "children", "className", "disabled", "onClick", "onMouseDown"]);
    var conditionalClassNames = {
      active: active,
      disabled: disabled
    };
    return (
      /* eslint-disable jsx-a11y/anchor-is-valid */
      _react.default.createElement("li", (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(conditionalClassNames, className)
      }), _react.default.createElement("a", {
        className: (0, _classnames.default)('dropdown-item', conditionalClassNames),
        href: "#",
        onClick: this._handleClick,
        onMouseDown: onMouseDown
      }, children))
      /* eslint-enable jsx-a11y/anchor-is-valid */

    );
  };

  return BaseMenuItem;
}(_react.default.Component);

exports.BaseMenuItem = BaseMenuItem;
(0, _defineProperty2.default)(BaseMenuItem, "propTypes", propTypes);
(0, _defineProperty2.default)(BaseMenuItem, "defaultProps", defaultProps);

var _default = (0, _menuItemContainer.default)(BaseMenuItem);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/components/MenuItem.react.js
// module id = 139
// module chunks = 0